import React from 'react'
import { CAREER_KUDA_OLD_ICON } from "assets/images"

const MemoizedImageKUDAOLD = () => {
  return (
    <img src={CAREER_KUDA_OLD_ICON} alt='kuda' className='kuda' />
  )
}
export default React.memo(MemoizedImageKUDAOLD) 
